// Colori di gruppo: il verde è riservato all'admin principale.
// NOTA: il campo `group_color` viene salvato dal backend alla nomina dell'admin secondario
// (server.py, nominate_secondary_admin). Qui lo si usa se presente, altrimenti si ripiega
// sull'ordine degli admin secondari (solo aspetto, nessuna scrittura).
export const GROUP_PALETTE = [
  { c: '#4d8ff7', hc: '#cfe1ff', name: 'azzurro' },
  { c: '#a855f7', hc: '#ecd9ff', name: 'viola' },
  { c: '#f066c8', hc: '#ffd6f3', name: 'rosa' },
  { c: '#38d6f5', hc: '#d4f7ff', name: 'ciano' },
];

export const PRIMARY_COLOR = { c: '#3ddba9', hc: '#c9ffee', name: 'verde' };

// mappa adminId -> colore, ordine stabile (indice nella lista passata)
export const buildGroupColorMap = (secondaryAdmins = []) => {
  const map = {};
  secondaryAdmins.forEach((admin, i) => {
    const id = admin.user_id || admin.id;
    const stored = admin.group_color;
    const fromPalette = GROUP_PALETTE[i % GROUP_PALETTE.length];
    const picked = GROUP_PALETTE.find((p) => p.c === stored) || fromPalette;
    map[id] = picked;
  });
  return map;
};

// variabili CSS per il neon e l'anello avatar
export const colorVars = (color) => ({
  '--c': color.c,
  '--hc': color.hc,
  '--ht-gc': color.c,
  '--ht-ring-c': color.c,
});
